import { DateInput, Input } from "basis";

export function validateBankName(...args) {
  const errors = Input.DEFAULT_PROPS.validate(...args);

  if (errors) {
    return errors;
  }

  return null;
}

export function validateAccountName(...args) {
  const errors = Input.DEFAULT_PROPS.validate(...args);

  if (errors) {
    return errors;
  }

  return null;
}

const BSB_REGEX = /^((\s*)?\d){6}\s*$/;

export function validateBSB(...args) {
  const errors = Input.DEFAULT_PROPS.validate(...args);

  if (errors) {
    return errors;
  }

  const [bsb] = args;

  if (BSB_REGEX.test(bsb) === false) {
    return "Needs to be 6 digits in length";
  }

  return null;
}

const ACCOUNT_NUMBER_REGEX = /^((\s*)?\d){6,9}\s*$/;

export function validateAccountNumber(...args) {
  const errors = Input.DEFAULT_PROPS.validate(...args);

  if (errors) {
    return errors;
  }

  const [accountNumber] = args;

  if (ACCOUNT_NUMBER_REGEX.test(accountNumber) === false) {
    return "Needs to be 6 to 9 digits in length";
  }

  return null;
}

const BPAY_BILLER_CODE_REGEX = /^((\s*)?\d){2,6}\s*$/;

export function validateBpayBillerCode(...args) {
  const errors = Input.DEFAULT_PROPS.validate(...args);

  if (errors) {
    return errors;
  }

  const [bpayBillerCode] = args;

  if (BPAY_BILLER_CODE_REGEX.test(bpayBillerCode) === false) {
    return "Needs to be 2 to 6 digits in length";
  }

  return null;
}

const BPAY_REFERENCE_NUMBER_REGEX = /^((\s*)?\d){2,21}\s*$/;

export function validateBpayReferenceNumber(...args) {
  const errors = Input.DEFAULT_PROPS.validate(...args);

  if (errors) {
    return errors;
  }

  const [bpayReferenceNumber] = args;

  if (BPAY_REFERENCE_NUMBER_REGEX.test(bpayReferenceNumber) === false) {
    return "Needs to be 2 to 21 digits in length";
  }

  return null;
}

// Source: https://emailregex.com
const EMAIL_REGEX =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export function validateEmail(...args) {
  const errors = Input.DEFAULT_PROPS.validate(...args);

  if (errors) {
    return errors;
  }

  const [email] = args;

  if (EMAIL_REGEX.test(email) === false) {
    return "Invalid email address";
  }

  return null;
}

const NAME_REGEX = /^[a-zA-Z ]+$/;

export const validateName = (...args) => {
  const errors = Input.DEFAULT_PROPS.validate(...args);

  if (errors) {
    return errors;
  }

  const [name] = args;

  if (NAME_REGEX.test(name) === false) {
    return "Only letters are allowed";
  }

  return null;
};

// See: https://en.wikipedia.org/wiki/Telephone_numbers_in_Australia#Mobile_phones
const AU_MOBILE_NUMBER_REGEX = /^\s*(\+\s*6\s*1|0)\s*[45](\s*\d){8}\s*$/;

export function validateAuMobileNumber(...args) {
  const errors = Input.DEFAULT_PROPS.validate(...args);

  if (errors) {
    return errors;
  }

  const [mobileNumber] = args;

  if (AU_MOBILE_NUMBER_REGEX.test(mobileNumber) === false) {
    return "Invalid mobile number";
  }

  return null;
}

// See: https://en.wikipedia.org/wiki/Telephone_numbers_in_New_Zealand#Mobile_phones
const NZ_MOBILE_NUMBER_REGEX = /^\s*(\+\s*6\s*4|0)\s*2(\s*\d){7,9}\s*$/;

export function validateNzMobileNumber(...args) {
  const errors = Input.DEFAULT_PROPS.validate(...args);

  if (errors) {
    return errors;
  }

  const [mobileNumber] = args;

  if (NZ_MOBILE_NUMBER_REGEX.test(mobileNumber) === false) {
    return "Invalid mobile number";
  }

  return null;
}

const CARD_NUMBER_REGEX = /^(\s*\d){16}\s*$/;

export function validateCardNumber(...args) {
  const errors = Input.DEFAULT_PROPS.validate(...args);

  if (errors) {
    return errors;
  }

  const [cardNumber] = args;

  if (CARD_NUMBER_REGEX.test(cardNumber) === false) {
    return "Invalid card number";
  }

  return null;
}

export function validateOver18YearsOld(...args) {
  const errors = DateInput.DEFAULT_PROPS.validate(...args);

  if (errors.length > 0) {
    return errors;
  }

  const [{ day, month, year }] = args;
  const birthday18 = new Date(
    Number(year) + 18,
    Number(month) - 1,
    Number(day),
  );

  if (birthday18 > new Date()) {
    errors.push("You must be 18+ years.");
    return errors;
  }

  return null;
}

export function validateDateAfterOtherDate(...args) {
  const errors = DateInput.DEFAULT_PROPS.validate(...args);

  if (errors.length > 0) {
    return errors;
  }

  const [
    endDate,
    {
      data: { travelStartDate: startDate, validationErrorMessage },
    },
  ] = args;

  if (
    new Date(startDate.year, Number(startDate.month) - 1, startDate.day) >
    new Date(endDate.year, Number(endDate.month) - 1, endDate.day)
  ) {
    return validationErrorMessage;
  }

  return null;
}

export function validateDateTodayOrGreater(...args) {
  const errors = DateInput.DEFAULT_PROPS.validate(...args);

  if (errors.length > 0) {
    return errors;
  }

  const [
    date,
    {
      data: { validationErrorMessage },
    },
  ] = args;

  // check against end of day.
  if (
    new Date(date.year, Number(date.month) - 1, date.day, 23, 59, 59) <
    new Date()
  ) {
    return validationErrorMessage;
  }
  return null;
}

const POSTCODE_REGEX = /^[0-9]{4}$/;

export function validatePostCode(...args) {
  const error = Input.DEFAULT_PROPS.validate(...args);

  if (error !== null) {
    return error;
  }

  const [postcode] = args;

  if (POSTCODE_REGEX.test(postcode) === false) return "Must be 4 digits";
  return null;
}

const ALPHA_ONLY_REGEX = /^[a-zA-Z ]+$/;

export function validateSuburb(...args) {
  const error = Input.DEFAULT_PROPS.validate(...args);

  if (error !== null) {
    return error;
  }

  const [suburb] = args;

  if (ALPHA_ONLY_REGEX.test(suburb) === false) {
    return "Only letters are allowed";
  }

  return null;
}
